<template>
    <div class="form-item">
        <label class="label-caption">Estabelecimento</label>
        <select :value="idSelecionado" @change="atualizarId" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.nmestabelecimento }}</option>
        </select>
    </div>
</template>


<script setup>
import { ref, watch, onMounted } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const props = defineProps({
  ckAddTodos:{type: Boolean, default: false},
  ckPesquisar: {type: Boolean, default: true},
  idSelecionado: {type: Number, default: null,},
});

const emit = defineEmits(["update:idSelecionado"]);

const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
  try {
      isLoading.value=true;
      const response = await genericPost('/listas/estabelecimentos', {idep: globalStore.idep, idsim: globalStore.idsim, ativo: 'S'});
      lsDados.value = response;
      if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmestabelecimento: 'TODOS' });}
  } catch (error) {console.error("Erro de conexão com a API:", error);
  }finally{isLoading.value=false;} 
};

const atualizarId = (event) => {
  emit("update:idSelecionado", Number(event.target.value));
};

onMounted(() => {
    if (props.ckPesquisar){fetchData();}
});

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
);
</script>